import React, { useState } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import NavbarAdmin from '../components/NavbarAdmin';

const AddStatGenre = () => {
  const [statistics2, setStatistics2] = useState({
    hommes: 0,
    femmes: 0,
    annee: ''
  });

  // Calculate the range of years
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 5; i <= currentYear + 5; i++) {
    years.push(i);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStatistics2({ ...statistics2, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'statistics_genre'), {
        ...statistics2,
        timestamp: Timestamp.now()
      });
      console.log("Document successfully written!");
      setStatistics2({
        hommes: 0,
        femmes: 0,
        annee: ''
      });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0 auto',
    maxWidth: '600px',
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  return (
    <div>
      <NavbarAdmin />
      <div style={containerStyle}>
        <h2 style={headingStyle}>Ajouter les Statistiques par Genre</h2>
        <form onSubmit={handleSubmit} style={formStyle}>
          <label>
            Hommes :
            <input
              type="number"
              name="hommes"
              value={statistics2.hommes}
              onChange={handleInputChange}
              step="0.01"
              required
              style={inputStyle}
            />
          </label>
          <label>
            Femmes :
            <input
              type="number"
              name="femmes"
              value={statistics2.femmes}
              onChange={handleInputChange}
              step="0.01"
              required
              style={inputStyle}
            />
          </label>
          <label>
            Année :
            <select
              name="annee"
              value={statistics2.annee}
              onChange={handleInputChange}
              required
              style={inputStyle}
            >
              <option value="">Sélectionnez l'année</option>
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </label>
          <button type="submit" style={buttonStyle}>Ajouter</button>
        </form>
      </div>
    </div>
  );
};

export default AddStatGenre;
